import React from 'react'
import Type from "./Type"

const returnFunction = (e)=>{
  return
}

export default function DataItem({clave,valor}) {
  if(!valor) valor = "none"
  try{
    valor = valor.toUpperCase()
  }
  catch(e){
    returnFunction(e)
  }
  if (clave === "No" && valor) {
    if(valor < 10) valor = "00"+valor
    else if (valor < 100) valor = "0" + valor
    return(
      <div className="data--item">
        <span className="data--item--left item--left">
          <p>{clave}</p>
        </span>
        <span className="subtitle data--item--right item--right">
          <p>{valor}</p>
        </span>
      </div>
    )
  }

  else if(clave === "TYPE" && valor !== "NONE") return(
    <div className="data--item">
      <span className="data--item--left item--left">
        <p>{clave}</p>
      </span>
      <span className="subtitle data--item--right item--right type">
        <p>
          {
            valor.map((type,index) =>{
              return <Type key={"valor"+index} type={type.type.name}></Type>
            })
          }
        </p>
      </span>
    </div>
    )
  
  else return (
    <div className="data--item">
        <span className="data--item--left item--left">
        <p>{clave}</p>
        </span>
        <span className="subtitle data--item--right item--right">
        <p>{valor}</p>
        </span>
    </div>
  )
}
